<template>
  <div class="datepicker">
    <div class="datepicker-visible-temp-date" @click="clickOnTempDate">{{visibleTempDate}}</div>
    <datepicker
      :date="visibleData"
      :option="option"
      :disabled="disabled"
      :limit="actualLimit"
      ref="datepicker"
      @change="visibleDataChange"
    />
  </div>
</template>
<style scoped>
  .datepicker-visible-temp-date {
    cursor: pointer;
    display: inline-block;
    min-height: 100%;
    min-width: 100%;
  }
  
</style>
<style>
  .datepicker .cov-vue-date .datepickbox {
    display: none;
  }
</style>
<script>
  import moment from 'moment';
  import Datepicker from 'vue-datepicker/vue-datepicker-es6.vue';

  export default{
    name: 'datePickerWrapper',
    components: {
      Datepicker,
    },
    props: [
      'row',
      'limit',
      'value',
      'disabled',
      'placeholder',
      'format',
      'datepickerOptions'
    ],
    data () {
      return {
        visibleData: {
          time: (typeof this.value != 'undefined' && moment(this.value).isValid())?this.value:'',
        },
        actualLimit: [],
        option: {
          type: 'min',
          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          placeholder: this.placeholder,
        }
      };
    },
    watch: {
      value: function(val) {
        this.visibleData.time = (typeof val != 'undefined' && moment(val).isValid())?val:'';
      },
      datepickerOptions: function (val) {
        if (val && typeof val === "function")
          this.option = Object.assign(this.option, val(this.row));
        else if (val)
          this.option = Object.assign(this.option, val);
      },
      limit: function (val) {
        if (val && typeof val === "function")
          this.actualLimit = val(this.row);
        else if (val)
          this.actualLimit = val;
      },
    },
    methods: {
      clickOnTempDate () {
        if (!this.disabled)
          this.$refs.datepicker.showCheck();
      },
      visibleDataChange (value) {
        // console.log(moment(value, 'YYYY-MM-DD HH:mm').format())
        this.$emit('input', value);
        this.$emit('blur', value);
        this.$emit('change', value);
      }
    },
    created () {
      if (this.datepickerOptions && typeof this.datepickerOptions === "function")
        this.option = Object.assign(this.option, this.datepickerOptions(this.row));
      else if (this.datepickerOptions)
        this.option = Object.assign(this.option, this.datepickerOptions);

      if (this.limit && typeof this.limit === "function")
        this.actualLimit = this.limit(this.row);
      else if (this.limit)
        this.actualLimit = this.limit;
    },
    computed: {
      visibleTempDate: function() {
        if (this.visibleData.time == '') return '-';
        const timeZone = moment().utcOffset();
        return moment(this.visibleData.time).format(this.format);
      }
    },
  };
</script>



// WEBPACK FOOTER //
// datePickerWrapper.vue?fdd22f5e